import { DotSeparatedLabels } from 'Components/shared/DotSeparatedLabels';
import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/lib/ui/tooltip';
import { EntityBasicInfoProps } from './index.types';

/**
 * EntityBasicInfo component displays a name with optional status tooltip and children
 */
export default function EntityBasicInfo({
  name,
  description,
  userStatus,
  isInactive,
  labels,
  children,
  className = '',
}: EntityBasicInfoProps) {
  const hasValidStatus = userStatus?.message && userStatus?.title;

  const renderStatus = () => {
    if (!hasValidStatus) return null;

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="text-sm text-black hover:text-gray-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 rounded"
            aria-label={`Status: ${userStatus.title}`}
          >
            {userStatus.title}
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{userStatus.message}</p>
        </TooltipContent>
      </Tooltip>
    );
  };

  const renderConversationInfo = () => {
    if (!labels || !labels.length) return null;

    return <DotSeparatedLabels labels={labels} />;
  };

  return (
    <div className={`text-center mt-[7px] px-2 ${className}`} data-private>
      <div className="flex items-center justify-center gap-4">
        {name && (
          <span
            className="text-[18px] leading-[21px] font-semibold max-w-[200px] line-clamp-2 break-word"
            style={{
              // Remove this, and line-clamp-2 will not work. Have fun! (╯°□°)╯︵ ┻━┻
              WebkitBoxOrient: 'vertical',
            }}
          >
            {`${name}${isInactive ? ' [Inactive]' : ''}`}
          </span>
        )}
        {renderStatus()}
      </div>

      {description && <div className="mt-1.5 break-word">{description}</div>}

      {renderConversationInfo()}
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
}
